import { app } from "modular-openscriptjs";
import { either, formatDate } from "../../helpers";
import { dc } from "../../declarations";

const h = app("h");

export default function CapaTransfersView(transfer, type, ...args) {
	return h.div(
		{ class: "bg-white border_bottom mb-2 shadow_sm p-3 rounded" },
		h.span(
			{ class: "text-gray-700" },
			h.span({ class: "text-black" }, `${transfer.transaction_id}`.toUpperCase()),
			" Confirmed. ",
			either(
				type == "transferred",
				[
					`You transferred ${dc.capaSymbol}${transfer.amount} to `,
					h["ojs-mention"](`@${transfer.recipient.username}`, {
						class: "text-primary",
					}),
				],
				[
					`You received ${dc.capaSymbol}${transfer.amount} from `,
					h["ojs-mention"](`@${transfer.sender.username}`, {
						class: "text-primary fw-500",
					}),
				],
			),
			` on ${formatDate(transfer.created_at)}`,
		),
		...args,
	);
}
